import { FilterOption } from '../../../components/_WMS/FilterComponent'
import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import { User } from '../../../interfaces/User/UserWMS'
import { YesNoBadge } from '../../../components/YesNoBadge'
import React from 'react'
import { PositionAutoCompleter } from '../../../components/PositionNew/components/PositionAutoCompleter'
import { createBackendTransformer, createDisplayTransformer } from '../../../types/filters'
import { UserAutoCompleter } from '../components/UserAutoCompleter'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 2,
    key: 'zoneId',
    label: 'Zona',
    type: 'precreated'
  },
  {
    order: 3,
    key: 'userId',
    label: 'Nombre',
    type: 'custom',
    Component: UserAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    order: 4,
    key: 'positionCode',
    label: 'Nombre Posición',
    type: 'custom',
    Component: PositionAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  }
]

export const defaultFilters = []

export const userTableHeaders: TableHeaderConfigWithType<User>[] = [
  {
    field: 'userAlias',
    title: 'Nombre',
    sortable: false
  },
  {
    field: 'userName',
    title: 'Email',
    sortable: false
  },
  {
    field: 'position',
    title: 'Nombre Posición',
    sortable: false,
    formater: (value: unknown) => (value as { positionName?: string })?.positionName ?? '-'
  },
  {
    field: 'active',
    title: 'Activo',
    sortable: false,
    formater: (value: unknown) =>
      React.createElement(YesNoBadge, { value: value as boolean })
  }
]
